import { 
    HANDLE_USER_MANAGEMENT_AUTH,
    REGISTER_ACCOUNT,
    REGISTER_ACCOUNT_SUCCESS,
    REGISTER_ACCOUNT_FAIL,
    DELETE_ACCOUNT,
    DELETE_ACCOUNT_SUCCESS,
    DELETE_ACCOUNT_FAIL
} from '../actions/types';
import { USER_MANAGEMENT as type } from "../actions/types";

const initialState = {
    handleUsereManagementAuth: false,

    registerAccountLoading: false,
    registerAccount: [],
    registerAccountError: false,

    deleteAccountLoading: false,
    deleteAccount: [],
    deleteAccountError: false,

    getDefaultWarehouseLoading: false,
    getDefaultWarehouse: '',
    getDefaultWarehouseError: false,

    userListAllLoading: false,
    userListAll: [],
    userListAllError: false
}

export default function userManagementReducer(state = initialState, action){
    switch(action.type){
        case type.GET_USER_LIST:
            return {
                ...state,
                userListAllLoading: true,
            }
        case type.GET_USER_LIST_SUCCESS:
            return {
                ...state,
                userListAll: action.payload,
                userListAllLoading: false
            }
        case type.GET_USER_LIST_FAIL:
            return {
                ...state,
                userListAllLoading: false,
                userListAllError: action.payload
            }
        case DELETE_ACCOUNT:
            return {
                ...state,
                deleteAccountLoading: true,
            }
        case DELETE_ACCOUNT_SUCCESS:
            return {
                ...state,
                deleteAccount: action.payload,
                deleteAccountLoading: false
            }
        case DELETE_ACCOUNT_FAIL:
            return {
                ...state,
                deleteAccountLoading: false,
                deleteAccountError: action.payload
            }
        case REGISTER_ACCOUNT:
            return {
                ...state,
                registerAccountLoading: true,
            }
        case REGISTER_ACCOUNT_SUCCESS:
            return {
                ...state,
                registerAccount: action.payload,
                registerAccountLoading: false
            }
        case REGISTER_ACCOUNT_FAIL:
            return {
                ...state,
                registerAccountLoading: false,
                registerAccountError: action.payload
            }
        case type.GET_DEFAULT_WAREHOUSE:
            return {
                ...state,
                getDefaultWarehouseLoading: true,
            }
        case type.GET_DEFAULT_WAREHOUSE_SUCCESS:
            return {
                ...state,
                getDefaultWarehouse: action.payload,
                getDefaultWarehouseLoading: false
            }
        case type.GET_DEFAULT_WAREHOUSE_FAIL:
            return {
                ...state,
                getDefaultWarehouseLoading: false,
                getDefaultWarehouseError: action.payload
            }
        default:
            return state;
    }
}